import {
  APIComponentAttributes,
  APIReferenceAttributes,
  ArdoqId,
} from '@ardoq/api-types';
import { GraphItemElementType } from './types';
import { componentInterface } from '@ardoq/component-interface';
import { referenceInterface } from '@ardoq/reference-interface';
import { fieldInterface } from '@ardoq/field-interface';
import { fieldOperations } from '@ardoq/core';

const getFields = (
  element: APIComponentAttributes | APIReferenceAttributes | null,
  elementType: GraphItemElementType
) => {
  if (!element) return [];
  switch (elementType) {
    case GraphItemElementType.NODE: {
      const component = element as APIComponentAttributes;
      return fieldInterface.getFieldsByComponentType(
        component.typeId,
        component.model
      );
    }
    case GraphItemElementType.EDGE: {
      const reference = element as APIReferenceAttributes;
      return fieldInterface.getFieldsByReferenceType(
        reference.type,
        reference.model ?? ''
      );
    }
    default:
      return [];
  }
};

const getElement = (elementId: ArdoqId, elementType: GraphItemElementType) => {
  switch (elementType) {
    case GraphItemElementType.NODE:
      return componentInterface.get(elementId);
    case GraphItemElementType.EDGE:
      return referenceInterface.get(elementId);
  }
};

export const getUrlFields = (
  elementId: string,
  elementType: GraphItemElementType
) => {
  const element = getElement(elementId, elementType);
  const fields = getFields(element, elementType);
  return fields
    .filter(fieldOperations.isURLField)
    .map(field => ({
      label: field.label,
      url: element ? element[field.name] : undefined,
    }))
    .filter(urlField => !!urlField.url);
};
